/** True se il fascicolo prevede un deposito cauzionale (flag o importo legacy). */
export function isDepositoCauzionaleAbilitato(amm) {
  if (!amm || typeof amm !== "object") return false;
  if (amm.deposito_cauzionale_abilitato === true) return true;
  if (amm.deposito_cauzionale_abilitato === false) return false;
  const n = Number(amm.deposito_cauzionale);
  return Number.isFinite(n) && n > 0;
}

/** Importo numerico se il deposito è abilitato e valorizzato, altrimenti null. */
export function importoDepositoCauzionale(amm) {
  if (!isDepositoCauzionaleAbilitato(amm)) return null;
  const n = Number(amm.deposito_cauzionale);
  return Number.isFinite(n) && n > 0 ? n : null;
}
